var exports = {
  "x6": "GuildListActionButton.module__button___dFRyen",
  "td": "GuildListActionButton.module__iconText___dFRyen",
  "ro": "GuildListActionButton.module__menuIcon___dFRyen",
};

module.exports = exports;
